import React from 'react'

import { scrollToElement, MainContext } from '@/utils'

import './src/styles'

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = ({ element }) => {
  return (
    <MainContext.Provider value={{ isServerSide: false }}>
      {element}
    </MainContext.Provider>
  )
}

export const onRouteUpdate = ({ location }) => {
  if (location.hash) {
    scrollToElement(location.hash, { behavior: 'auto' })
  }
}

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  // Do not scroll when pathname remains the same.
  if (prevRouterProps) {
    return routerProps.location.pathname !== prevRouterProps.location.pathname
  }

  return false
}
